import { useState } from "react";
import { Link } from "react-router-dom";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";

interface NavProps {
  bioRef?: any;
  projectRef?: any;
  contactRef?: any;
  showcase: boolean;
}

interface NavItemProps {
  name: string;
}

const NavItem = ({ name }: NavItemProps) => {
  return (
    <span className="relative pb-1 group cursor-pointer text-gray-400 hover:text-white transition-colors duration-300 font-medium">
      {name}
      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-violet-500 transition-all duration-300 group-hover:w-full" />
    </span>
  );
};

export const NavBar = ({
  bioRef,
  projectRef,
  contactRef,
  showcase = false,
}: NavProps) => {
  const [openMenu, setOpenMenu] = useState(false);

  return (
    <nav className="fixed top-0 w-full z-50 px-4 py-4">
      <div className="max-w-7xl mx-auto bg-gray-900/40 backdrop-blur-md border border-gray-800 rounded-3xl px-6 py-3 shadow-2xl">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center space-x-2 group">
            <div className="p-2 bg-violet-500/10 rounded-xl group-hover:bg-violet-500/20 transition-colors duration-300">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-violet-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z"
                />
              </svg>
            </div>
            <span className="font-bold text-xl tracking-tight text-white">
              Reece Carey
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-10">
            {showcase ? (
              <Link to="/">
                <NavItem name="Home" />
              </Link>
            ) : (
              <>
                <div
                  onClick={() => {
                    bioRef.current.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                  }}
                >
                  <NavItem name="About" />
                </div>
                <div
                  onClick={() => {
                    projectRef.current.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                  }}
                >
                  <NavItem name="Projects" />
                </div>
                <div
                  onClick={() => {
                    contactRef.current.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                  }}
                >
                  <NavItem name="Contact" />
                </div>
              </>
            )}
          </div>

          {/* Mobile Toggle */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setOpenMenu(!openMenu)}
              className="text-white focus:outline-none p-2 hover:bg-white/5 rounded-lg transition-colors"
            >
              {openMenu ? (
                <AiOutlineClose size={24} />
              ) : (
                <AiOutlineMenu size={24} />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
            openMenu ? "max-h-64 opacity-100 mt-4" : "max-h-0 opacity-0"
          }`}
        >
          <div className="flex flex-col space-y-4 pb-4 text-center">
            {showcase ? (
              <Link to="/">
                <NavItem name="Home" />
              </Link>
            ) : (
              <>
                <div
                  onClick={() => {
                    bioRef.current.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                    setOpenMenu(false);
                  }}
                >
                  <NavItem name="About" />
                </div>
                <div
                  onClick={() => {
                    projectRef.current.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                    setOpenMenu(false);
                  }}
                >
                  <NavItem name="Projects" />
                </div>
                <div
                  onClick={() => {
                    contactRef.current.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                    setOpenMenu(false);
                  }}
                >
                  <NavItem name="Contact" />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
